import { createStore } from 'effector';
import { AiAgentCategoriesState } from '@nx-frontend/shared/types';

export const aiAgentCategoriesInitialState: AiAgentCategoriesState = {
  categories: [],
  selectedId: 'all',
};

export const $aiAgentCategories = createStore<AiAgentCategoriesState>(aiAgentCategoriesInitialState);
